import React, { Component } from 'react';

import CommonSubHeader from '../../SubHeader';

import './SubHeader.css';
import FullTextSearch from './FullTextSearch';
import { inject, observer } from 'mobx-react';
import AirButton from '../../../../common/components/AirButton';
import CreateRouteTask from "./CreateRouteTask";

@inject('translationsStore')
@observer
export default class SubHeader extends Component {
  constructor(props) {
    super(props);
    this.CreateRouteRef = React.createRef();
  }

  componentDidMount = () => {
    this.CreateRouteInstance = this.CreateRouteRef.current.wrappedInstance;
  };

  render() {
    const { translationsStore } = this.props;
    return (
      <CommonSubHeader>
        <FullTextSearch placeholder={this.props.translationsStore.translate('search.placeholderSimple')} />
        <div className="filtersExport">
          <AirButton
            size="large"
            light
            label={translationsStore.translate('routePlanning.createRoute.buttonLabel')}
            onClick={() => this.CreateRouteInstance.show()}
          />
        </div>
        <CreateRouteTask ref={this.CreateRouteRef} width={560} />
      </CommonSubHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/SubHeader/SubHeader.js